<template>
  <div class="homeswiper">
    <!-- <div class="dan_img error_img"
         v-show="childData.length==0">
      <div class="error_img_conter">
        <img :src="error_login"
             alt="">
      </div>
    </div> -->
    <!-- v-if=" childData && childData.length!==0" -->
    <div class="duo ">

      <!-- Swiper -->
      <swiper class="gallery-top"
              ref="swiperTop"
              :options="swiperOptionTop">
        <swiper-slide v-for="(item,index) in childData.picList"
                      :key="index">
          <img :src="item.headimg|filterFun_as"
               alt="图片加载失败"
               class="">
          <div class="da_img_conter _width">

            <div class="mose_desc _width"
                 v-if="item.introduce">
              {{item.introduce}}
            </div>
          </div>

        </swiper-slide>
      </swiper>

      <!-- 缩略图集 -->
      <div class="side _width ">
        <swiper ref="swiperThumbs"
                class="side_list"
                :options="swiperOptionThumbs">
          <swiper-slide v-for="(item,index) in childData.picList"
                        :key="index"
                        @click.native="swiper_active(item.imageData)">
            <img :src="item.headimg|filterFun_sss"
                 alt="图片加载失败"
                 class="_Width">
            <!-- 图文信息 -->
            <div class="tips">
              <span></span>
            </div>
            <!-- 图文信息 -->
            <div class="mose">{{index+1}}/{{childData.picList.length}}</div>

          </swiper-slide>
          <!-- v-if="index+1 ==childData.length" -->
          <div class=" end_img"
               v-if="childData.picList">
            <p>最后一页了</p>
          </div>
        </swiper>

        <div class="swiper-button-next swiper-button-white"
             slot="button-next"><img src="@/assets/image/works/right.png"
               alt=""></div>
        <div class="swiper-button-prev swiper-button-white"
             slot="button-prev"><img src="@/assets/image/works/left.png"
               alt=""></div>
      </div>
    </div>

  </div>
</template>

<script>
// 引入插件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "homeSwiper",
  props: ['childData'],
  data () {
    return {
      defaultImg: 'this.src="' + require('@/assets/image/common/loading.gif') + '"',//未加载
      error_login: require('@/assets/image/common/loading.gif'),
      swiperOptionTop: {
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper
      const swiperThumbs = this.$refs.swiperThumbs.swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  },
  components: {
    swiper,
    swiperSlide
  },

  filters: {
    filterFun_as: function (value) {
      return value.replace('.jpg', '_activity_s.jpg').replace('.png', '_activity_s.png').replace('.jpeg', '_activity_s.jpeg').replace('.gif', '_activity_s.gif')//最大
    },

    filterFun_sss: function (value) {
      return value.replace('.jpg', '_sss.jpg')//最小
    }
  },

  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper;

    }
  },

  methods: {
    // 点击swiper
    swiper_active (item) {
      this.$emit('parentEvent', item)
    }
  },

}
</script>
<style  scoped>
.border {
  float: left;
  width: 100%;
}

.typeHeight1 {
  min-height: 6rem;
}
.typeHeight2 {
  min-height: 7rem;
}

.dan_img {
  width: 100%;
  height: 6rem;
  position: relative;
  display: flex;
  justify-content: center;
  transition: all 0.3s;
}
.dan_img .covers {
  max-width: 100%;
  height: 100%;
  object-fit: contain;
}

.da_img_conter {
  transition: all 0.3s;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  border: 1px solid #eee;
  box-sizing: border-box;
}

.mose_desc {
  opacity: 0;
  position: absolute;
  bottom: 0;
  z-index: 20px;
  height: 0.5rem;
  line-height: 0.5rem;
  background-image: linear-gradient(
    -180deg,
    hsla(0, 0%, 74.9%, 0),
    rgba(0, 0, 0, 0.78) 97%
  );
  transition: all 0.3s;
  box-sizing: border-box;
  color: #fff;
  font-size: 0.16rem;
  padding: 0 0.1rem;
  box-sizing: border-box;
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  word-break: break-all;
}
.duo >>> .swiper-wrapper {
  transition: all 0.3s;
}
.duo >>> .swiper-wrapper:hover,
.duo >>> .swiper-slide:hover {
  background-color: #f5f5f5;
}

.da_img_conter:hover .mose_desc {
  opacity: 1;
}
.end_img {
  /* border: 1px solid blue; */
  /* width: 100px; */
  background: rgba(0, 0, 0, 0.05);
  height: 0.75rem;
  padding: 0 0.1rem;
}
.end_img p {
  width: 1rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.5);
}

.homeswiper {
  height: 100%;
}
/* 缩略图滚动查看 */

/* 封面 */
.homeswiper .gallery-top {
  height: 5.62rem;
}
.swiper-container {
  height: 100%;
}

.item-container img {
  max-width: 100%;
  height: 100%;
}
.side .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.homeswiper >>> .swiper-slide {
  height: 100%;
  width: 100%;
  /* background: rgba(0, 0, 0, 0.05); */
  background-size: cover !important;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}
.gallery-top >>> .swiper-slide {
  display: flex;
  justify-content: center;

  float: left;
}

.gallery-top >>> .swiper-slide img {
  float: left;
  max-width: 100%;
  max-height: 100%;
}

.side_list >>> .swiper-slide {
  width: 20%;
  height: 0.75rem;
  opacity: 0.5;
  /* border: 1px solid blue; */
}

.swiper-slide-active .tips,
.swiper-slide-active .tips span {
  display: block;
}

.homeswiper >>> .swiper-slide-active,
.swiper-slide-active .mose {
  opacity: 1;
}

/* .side_list >>> .swiper-slide {
  float: left;
  box-sizing: border-box;
  opacity: 0.8;
  cursor: pointer;
} */

/* 当前焦点 */
.mose {
  float: left;
  width: 100%;
  height: 0.21rem;
  text-align: center;
  font-family: "PingFang SC", "Lantinghei SC", "Microsoft YaHei", "HanHei SC",
    "Helvetica Neue", "Open Sans", Arial, "Hiragino Sans GB", "微软雅黑",
    STHeiti, "WenQuanYi Micro Hei", SimSun, sans-serif;

  font-size: 0.12rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.21rem;
  color: #333333;
  position: absolute;
  bottom: -0.2rem;
  opacity: 0;
  transition: all 0.35s;
}

/* 三角父级 */
.tips {
  width: 100%;
  height: 100%;
  z-index: 20;
  position: absolute;
  top: 0;
  display: none;
  /* border: 1px solid rgb(26, 25, 25, 0.5); */
}

/* 三角形 */
.tips span {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 7px solid rgba(0, 0, 0, 0.6);
  position: absolute;
  left: 50%;
  top: -7px;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, 0%);
  -webkit-transition: opacity 0.4s;
  transition: opacity 0.4s;
  display: none;
}

/* 缩略图集 */
.side {
  display: flex;
  position: relative;
}

.side_list {
  float: left;
  padding: 0.12rem 0 0.2rem;
  margin: 0 5%;
  width: 100%;
  float: left;
}

/* 切换按钮 */
.side >>> .swiper-button-prev.swiper-button-white,
.side >>> .swiper-button-next.swiper-button-white {
  width: 0.3rem;
  height: 0.3rem;
  overflow: hidden;
  cursor: pointer;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  padding: 0.07rem;
  display: flex;
  /* background-color: palegoldenrod; */
  justify-content: center;
  align-items: center;
}

.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after,
.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after {
  font-size: 0.1rem;
  content: "";
}

.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 0.1rem;
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 0.1rem;
}

/* 缩略图集 :end */
.swiper-button-next img,
.swiper-button-prev img {
  object-fit: scale-down;
  width: 0.1rem;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper/workSwiper_type1.vue